const header = {
  homepage: 'https://github.com/gehlotlalit',
  title: 'LM.',
}

const about = {
  name: 'Lalit Malviya',
  role: 'Front End Developer',
  description:
    'As a passionate and detail-oriented fresher frontend developer, I bring a strong foundation in modern web development technologies,   I am excited to bring my enthusiasm and foundational knowledge to a dynamic team, where I can contribute to creating impactful web experiences and continue growing as a frontend developer',
  resume: 'https://example.com',
  social: {
    linkedin: 'https://www.linkedin.com/in/lalit-malviya-1168b3266/',
    github: 'https://github.com/gehlotlalit',
  },
}

const projects = [
  { 
    icon:"https://img.icons8.com/?size=100&id=17949&format=png&color=000000",
    name: 'Google Search Engine',
    description:
      'Developed a responsive web application using React, Tailwind CSS, JavaScript, and Context API for efficient state management and a modern, user-friendly interface.',
    stack: ['React', 'Tailwind CSS', 'Javascript','Context API'],
    sourceCode: 'https://github.com/gehlotlalit/Google-Search-2.0.git',
    livePreview: 'https://myowngoogle.netlify.app/',
  },
  {
    icon:"https://img.icons8.com/?size=100&id=2212PsH6OEOq&format=png&color=000000",
    name: 'Full Stack Ecommerce',
    description:
      'Built a full-stack ecommerce application using React, Tailwind CSS, Material UI, Firebase, and Redux for state management, ensuring a responsive and scalable user experience.',
    stack: ['React', 'Tailwind CSS', 'Material UI','Firebase', 'Redux'],
    sourceCode: 'https://github.com/gehlotlalit/E-Commerce-Website.git',
    livePreview: 'https://myecom-14fe8.web.app/',
  },
  {
    icon:"https://img.icons8.com/?size=100&id=P7UIlhbpWzZm&format=png&color=000000",
    name: 'Gmail Clone',
    description:
      'Created a Gmail clone using React, Tailwind CSS, Redux, Firebase, and Framer Motion, delivering a responsive, state-managed, and interactive email application.',
    stack: ['React','Tailwind Css', 'Redux','Firebase','Framer-Motion'],
    sourceCode: 'https://github.com/gehlotlalit/GmailClone.git',
    livePreview: 'https://clone-e3fee.web.app/',
  },
]

const skills = [
  'HTML',
  'CSS',
  'JavaScript',
  'Bootstrap',
  'Tailwind CSS',
  'React',
  'Redux',
  'Material UI',
  'Git',
  'Github',
  'Nodejs',
  'Firebase',
]

const contact = {
  email: 'gehlotlalit786@gmail.com',
}

export { header, about, projects, skills, contact }
